import * as PropTypes from 'prop-types';
/**
 * @hidden
 */
export var toIconName = function toIconName(iconClass) {
  return iconClass.replace(/^k-i-/, '');
};
/**
 * @hidden
 */
export var toIconClass = function toIconClass(name) {
  return 'k-i-' + name;
};
/**
 * @hidden
 */
export var svgIconPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  viewBox: PropTypes.string.isRequired
});